import { render, staticRenderFns } from "./CreateProfile.vue?vue&type=template&id=9368b1a6&scoped=true"
import script from "./CreateProfile.vue?vue&type=script&lang=js"
export * from "./CreateProfile.vue?vue&type=script&lang=js"
import style0 from "./CreateProfile.vue?vue&type=style&index=0&id=9368b1a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9368b1a6",
  null
  
)

export default component.exports